import { ReactNode, useId } from 'react'

import { SetOptional } from 'type-fest'

import * as dialog from '@zag-js/dialog'
import { normalizeProps, useMachine } from '@zag-js/react'

import styles from './Dialog.module.css'

export interface DialogProps {
  dialogContext: SetOptional<dialog.Context, 'id'>
  children: ReactNode
}

export const DialogView = ({ dialogContext = {}, children }: Partial<DialogProps>) => {
  const id = useId()

  const [state, send] = useMachine(
    dialog.machine({
      id: dialogContext.id || id,
      open: dialogContext.open,
    }),
    {
      context: dialogContext,
    }
  )

  const api = dialog.connect(state, send, normalizeProps)

  return (
    <>
      {api.open && (
        <div>
          <div className={styles.dialogBackdrop} {...api.getBackdropProps()} />
          <div className={styles.dialogPositioner} {...api.getPositionerProps()}>
            <div className={styles.dialogContent} {...api.getContentProps()}>
              <button className={styles.dialogCloseButton} {...api.getCloseTriggerProps()}>
                X
              </button>
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
